import React from "react"
import Nav from "./components/nav"
import Banner from "./components/banner"
import Panel from "./components/panel"
import PanelTitle from "./components/panel-title"
import CourseDetail from "./components/course-details"
import Section2 from "./components/section2"
import Section4 from "./components/section4"
import Section5 from "./components/section5"
import Section7 from "./components/section7"
import Section8 from "./components/section8"
import Img from "./components/img"
import {Row, Col} from "antd"
import "normalize.css"
import "./index.scss"
import TeacherSlider from './components/TeacherSlider'
import smoothscroll from 'smoothscroll-polyfill';
import 'sal.js/dist/sal.css';
import sal from "sal.js";

class App extends React.Component {

    state = {
        show: false
    }


    componentDidMount() {

        smoothscroll.polyfill();

        setTimeout(() => {
            sal({
                threshold: 0.4,
                once: true
                // once: false
            });
        }, 1000);

    }

    componentDidUpdate() {

    }

    componentWillUnmount() {
        // window.location.reload(true);

    }

    render() {

        return (
            <div className="container">
                <Nav/>
                <Banner/>
                <Panel id="outline">
                    <PanelTitle num={"01"} enTitle="Course Details" mainTitle="课程大纲" subTitle={"高端制定，引领前沿"}
                                content={"3个月12周的课程，合理分配。包含产品思维、交互逻辑、运营插画、动效演示、作品集包装。课程内容适合零基础以及进阶需求的同学。并根据市场变化和学员就业反馈由像素范儿教学部研发每期课程，研究最新黑科技和前沿软件，帮助学生更好地满足企业需求适应快节奏变化。"}/>
                    <CourseDetail/>
                </Panel>
                <Panel id="work"  style={{maxWidth:"none",padding:0}}>
                    <PanelTitle style={{maxWidth:"1240px",padding:"20px",margin:"0 auto"}}  num={"02"} mainTitle={"学员佳作"} subTitle={"一直在输出，一直在超越"}
                                content={"三个月的刻苦学习期间，学生产出优秀作品，包括界面 、动效、banner、图标、以及整套作品集输出"}/>
                    <Section2/>
                </Panel>
                <Panel id="go">
                    <Row type="flex" justify="center">
                        <Col xs={{span: 24, order: 2}} md={{span: 16, order: 1}}>
                            <Img className={"go-img"} src={"https://img.uigreat.com/szpxfer/com_logo.png"}/>
                        </Col>
                        <Col xs={{span: 24, order: 1}} md={{span: 8, order: 2}}>
                            <PanelTitle align="left" num={"03"}
                                        mainTitle="学员去向"
                                        subTitle="梦想总要有，万一实现了呢！"
                                        content="学员高薪入职各大一线互联网公司，足迹遍布全国；靠实力说话，让作品发声项目实战作品集包装，就业指导…你想要的都在这里！"/>
                        </Col>
                    </Row>
                </Panel>

                <Panel id="circle" style={{marginBottom: "100px",maxWidth:"none",padding:0}}>
                    <PanelTitle style={{maxWidth:"1240px",padding:"20px",margin:"0 auto"}} num={"04"}
                                mainTitle={"圈子学习"}
                                subTitle={"一个人走的快，一群人走的远"}
                                content={"像素范儿已经形成了成熟的设计圈子文化，我们有8个微全国群，以及现在建立的深圳像素范儿的交流群，定期开办且慢分享会，以及带同学参与互联网活动。无论你在哪里发展，都可以找到我们像素范的师兄师姐，并且会有私活、内推等机会。"}/>
                    <Section4/>
                </Panel>
                <Panel id="offer" style={{paddingBottom: "246px"}}>
                    <PanelTitle num={"05"} mainTitle="快速入职"
                                subTitle={"我们不包你就业，但帮助你就业"}
                                content={"毕业后我们会建立快速入职计划，老师会制定学员任务，监督学员。在求职过程中有问题可以及时与老师沟通反馈，老师会做出相应指导，为你在求职路上保驾护航。"}/>
                    <Section5/>
                </Panel>

                <Panel id="lector" className={"section-10"} style={{paddingTop: 0}}>
                    <PanelTitle align="left" className={`section-10-panel-title`}
                                num={"06"}
                                mainTitle={<div className="section-10-title">师资力量</div>}
                                subTitle={"术业有专攻，精益求精"}
                    />
                    <TeacherSlider/>
                </Panel>
                <Panel id="surround" style={{maxWidth:"none",padding:0}}>
                    <PanelTitle style={{maxWidth:"1240px",padding:"100px 20px",margin:"0 auto"}} num={"07"} mainTitle="环境展示"
                                subTitle={"专业的教学设备，舒适的住宿环境"}
                                content={"27人精品小班，一对一单独辅导，全苹果设备教学；完全0基础入学，授之以渔持续学习，有问题第一时间解决，让你收获更多。周边住宿方便，环境优雅，价格实惠。"}/>
                    <Section7/>
                </Panel>
                <Panel id="apply" style={{maxWidth:"none",padding:0}}>
                    <PanelTitle num={"08"} mainTitle="报名咨询"
                                subTitle={"欢迎你以及期待你的加入"} style={{padding:"20px"}}/>
                    <Section8/>
                </Panel>
                <Panel style={{paddingTop: 0}} bgcolor={"#26282B"}>
                    <div className="footer">优阁网-UIGREAT <a style={{color: "#ffffff"}} href="http://beian.miit.gov.cn/"
                                                           target="_blank"
                                                           rel="noopener noreferrer">京ICP备15031701号-2</a></div>
                </Panel>
            </div>
        )
    }


}

export default App